import React, { FC, useState } from "react";

import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

import CustomerCardSignModal from "@/components/features/ToDos/CustomerCardPage/CustomerPreview/components/CustomerCardSignModal/CustomerCardSignModal";
import { DocumentPreview } from "@/components/organisms";
import config from "@/config";
import { useNavigation } from "@/shared/hooks";

import { StyledActionButtons } from "./styled";

type CustomerPreviewProps = {
    document: string;
    requestId: string;
    signedIn: string;
    signedBy: string;
};

const CustomerPreview: FC<CustomerPreviewProps> = ({ document, requestId, signedIn, signedBy }) => {
    const [isDocumentSigned, setIsDocumentSigned] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const { t } = useTranslation();
    const { navToRoot } = useNavigation();

    const url = `${config.SPAPI_URL}/api/document/request/content/${document}`;

    const onSignDocument = () => setIsDocumentSigned(true);

    const handleCloseModal = () => {
        if (isDocumentSigned) {
            navToRoot();
        }

        setOpenModal(false);
    };

    return (
        <>
            <DocumentPreview
                url={url}
                title={t("CustomerCard.CustomerPreview.DocumentTitle", { signator: signedBy })}
            />
            <StyledActionButtons>
                <Button fullWidth data-testid="sign-btn" onClick={() => setOpenModal(true)}>
                    {t("CustomerCard.CustomerPreview.ToSign")}
                </Button>
            </StyledActionButtons>
            <CustomerCardSignModal
                onRequestSign={onSignDocument}
                isSigned={isDocumentSigned}
                onClose={handleCloseModal}
                openModal={openModal}
                requestId={requestId}
                signedIn={signedIn}
                signedBy={signedBy}
            />
        </>
    );
};

export default CustomerPreview;
